<div
	class="indicator"
	[ngClass]="{
		high: healthIndicator() === indicator.High,
		medium: healthIndicator() === indicator.Medium,
		low: healthIndicator() === indicator.Low
	}">
	<div class="bar" [ngStyle]="{ 'flex-basis.%': percentage$() }"></div>
</div>
